import { EventEmitter, OnInit } from '@angular/core';
import { NotificationType } from '@ml/notifications/types/enums';
var NotificationItemComponent = /** @class */ (function () {
    function NotificationItemComponent() {
        this.redirect = new EventEmitter();
        this.remove = new EventEmitter();
        this.notificationTypes = NotificationType;
    }
    NotificationItemComponent.prototype.ngOnInit = function () { };
    Object.defineProperty(NotificationItemComponent.prototype, "cursor", {
        get: function () {
            return (this.notification.type === NotificationType.TASK ||
                this.notification.type === NotificationType.ORDER);
        },
        enumerable: true,
        configurable: true
    });
    return NotificationItemComponent;
}());
export { NotificationItemComponent };
